import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { ApirequestService } from 'src/app/api/request/apirequest.service';
import { ApiFunctions } from 'src/app/shared/functions/api-functions';
import { FormFunctions } from 'src/app/shared/functions/form-functions';
import { ListSelectionComponent } from '../../components/dynamic-modals/list-selection/list-selection.component';
import { OpenRegisterComponent } from '../../components/dynamic-modals/open-register/open-register.component';
import { ActionButtonsService } from '../../services/action-buttons.service';
import { NotificationService } from '../../services/notification.service';
import { TabService } from '../../services/tab.service';
import { Tab } from '../../tab-models/tab.model';

@Component({
  selector: 'app-new-administrator',
  templateUrl: './new-administrator.component.html',
  styleUrls: ['./new-administrator.component.scss']
})
export class NewAdministratorComponent {
  @Input() tab: Tab;
  @Input() data;

  public loading: boolean = false;
  public formAdministrator: FormGroup;
  //public formProtocol: FormGroup;
  public addressForm: FormGroup;

  private subscriptions: Array<Subscription> = [];

  private formFunctions = new FormFunctions;

  modalRef: MDBModalRef | null = null;
  modalRefAddress: MDBModalRef | null = null;
  constructor(private modalService: MDBModalService, private _tabs: TabService, private _api: ApirequestService, private fb: FormBuilder, private _apifunctions: ApiFunctions, private _buttons: ActionButtonsService, private _notification: NotificationService){

  }


  ngOnInit(): void {
    console.log(this.data)
    console.log(this.tab)
    this.createForm();
  }

  createForm() {
    this.formAdministrator = this.fb.group({
      provider: this.fb.group({
        cif: [null],
        name: [null, [Validators.required]],
        email: [null],
        phone: [null],
        mobile: [null],
      })
    });


    this.subscriptions.push(
      this.formAdministrator.valueChanges.subscribe(
        () => {
          this.tab.modifiedData = true;
        }
      )
    );


    this.addressForm = this.fb.group({
      address:[''],
      postalcode: this.fb.group({
        province_id:[null],
        province:[{value:null, disabled: false}],
        population_id:[null],
        population:[{value:null, disabled: false}],
        description:[{value:null, disabled: false}],
        id:[null]
      })
    });

    this.subscriptions.push(
      this.addressForm.valueChanges.subscribe(
        () => {
          this.tab.modifiedData = true;
        }
      )
    );
  };

  selectLocation(){
    this.modalRefAddress = this.modalService.show(ListSelectionComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog modal-fluid',
            data: {
              modal_header: 'Seleccionar Población',
              list_headers: [
                'CP',
                'Población',
                'Provincia',
              ],
              list_fields: [
                { entity: 'postalcode', field: 'description'},
                { entity: 'postalcode', field: 'population' },
                { entity: 'postalcode', field: 'province' },
              ],
              list_entity: 'postalcode',
              list_endpoint: 'postalcodes',
            }
          })

      this.subscriptions.push(
        this.modalRefAddress.content.selectedRegister.subscribe(register => {
          if(register) {
            this.formFunctions.rellenarFormulario(this.addressForm.controls.postalcode, register);
            this.addressForm.markAsDirty();
          }
        })
      );

      this.modalService.close.subscribe(() => this.modalRefAddress.content.onClosed())
  }

  onSubmit(){
    this.formAdministrator.markAllAsTouched()
    //this.formProtocol.markAllAsTouched()

    if(this.formAdministrator.valid){
      this._buttons.setLoading(true);
      const params: {provider?: any | null,provideraddress?: any | null} = {};
      this.formFunctions.fillFormParams((this.formAdministrator.controls.provider as FormGroup), this.data.entity, params);
      params.provider.typeprovider_id = this.data.entity_type;


      if(this.addressForm.dirty) {
        let addressValues = this.addressForm.value;

        params.provideraddress = {
          address: addressValues.address,
          postalcode_id: addressValues.postalcode.id,
          province_id: addressValues.postalcode.province_id,
          population_id: addressValues.postalcode.population_id,
        }
      }



      console.log(params)
      this.subscriptions.push(
        this._api.post(this.data.saveEndpoint, JSON.stringify(params)).subscribe(
          response => {
            let provider = response.response.provider
            this._buttons.reloadListTab(this.data.saveEndpoint, this.data.entity_type);
            this._buttons.setLoading(false);
            this._notification.notificacionOK(this._notification.getInsertMsg())

            //Abre el modal de apertura de registro
            this.modalRef = this.modalService.show(OpenRegisterComponent, {
                    keyboard: false,
                    ignoreBackdropClick: true,
                    class: 'modal-dialog',
                    data: {
                      heading: 'Registro Creado',
                      text: 'Registro creado correctamente, ¿desea acceder al registro?',
                      register: provider,
                      form_entity: this.data.entity,
                      form_entity_type: this.data.entity_type,
                    }
                  })

            this._tabs.removeTabByTabId(this.tab.tabId);
          },
          error => {
            this._buttons.setLoading(false);
          }
        )
      );

    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(e => e.unsubscribe());
  }


}
